import * as React from "react";
import type { SVGProps } from "react";

interface StartShootoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const StartShootout = ({ cancelled = false, ...props }: StartShootoutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M1.07 4.47h20.76v12H1.07z" />
      <path
        stroke="#000"
        strokeDasharray="0.4,1.9"
        strokeLinecap="round"
        d="M5 7.5h14M5 9.8h14M5 12.1h14M5 14.4h14"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        stroke="#FFF"
        strokeWidth={0.75}
        d="M20.9 3.63a1.97 1.97 0 0 1 1.98 1.97v11.14c-1.68 1.1-1.58.35-1.9.47l-.22-11.24-17.3-.22-.22 11c-1.67 1.09-1.57.34-1.89.46L1.12 5.6A1.97 1.97 0 0 1 3.1 3.63z"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M6.82 18.71c-.8.66-.93 1.84-.28 2.65l.59.72c.55.69 1.51.9 2.3.5l3.97-1.97.14.15a5.37 5.37 0 0 0 7.1.64l.17-.14a5.35 5.35 0 0 0 1.82-5.43l-.01-.07.05-.04c.57-.64.64-1.6.14-2.33l-.08-.11a1.88 1.88 0 0 0-2.15-.58l-.04.02a5.36 5.36 0 0 0-6.34.02l-.18.14a1.6 1.6 0 0 0-.5 1.75l.02.07-1.03.84a1.66 1.66 0 0 0-1.81.04l-.12.08z"
        />
        <path
          fill="#000"
          d="M7.2 19.18a1.28 1.28 0 0 0-.2 1.8l.6.73c.37.46 1.02.6 1.56.34l4.2-2.1a.28.28 0 0 1 .35.09l.02.02a4.76 4.76 0 0 0 8.23-4.44l-.03-.07.02-.01.13-.09c.54-.44.62-1.25.18-1.8a1.28 1.28 0 0 0-1.8-.2h.03l-.06-.06a4.77 4.77 0 0 0-5.85-.18l-.18.13a1 1 0 0 0-.15 1.41l.04.05c.02.02.02.06 0 .08l-1.76 1.41a.06.06 0 0 1-.08 0 1.06 1.06 0 0 0-1.49-.16zm.63.78 3.76-3.05a.06.06 0 0 1 .08 0c.37.46 1.04.53 1.5.16l1.74-1.41c.46-.37.53-1.04.16-1.5l-.04-.04.16-.12a3.77 3.77 0 0 1 4.84.38l.14.14a.5.5 0 0 0 .84-.17.26.26 0 0 1 .08-.11c.12-.1.3-.08.4.04s.07.3-.04.4a.26.26 0 0 1-.18.05.5.5 0 0 0-.46.72 3.76 3.76 0 0 1-1 4.57 3.77 3.77 0 0 1-5.3-.59l-.02-.01a1.28 1.28 0 0 0-1.58-.36l-4.2 2.1a.28.28 0 0 1-.34-.08l-.59-.73a.28.28 0 0 1 .05-.4Z"
        />
        <path
          fill="#000"
          d="M15.95 15.23c-.99.82-1.14 2.3-.33 3.3a2.3 2.3 0 0 0 3.25.35c1-.81 1.15-2.29.34-3.3a2.3 2.3 0 0 0-3.26-.35m.64.78a1.3 1.3 0 0 1 1.84.2c.47.58.38 1.43-.19 1.9a1.3 1.3 0 0 1-1.84-.2 1.36 1.36 0 0 1 .19-1.9"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default StartShootout;
